import { Breadcrumb, Carousel } from "antd";
import { Link } from "react-router-dom";
import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  color: var(--black);
  text-align: center;
  background-color: var(--white);
  height: 100%;
  width: 100%;
  padding: 130px 158px 0 158px;
  overflow: hidden;

  .document-pdf {
    width: 100% !important;
    height: 500px !important;
  }

  .row-col-3 {
    @media only screen and (max-width: 1024px) {
      .ant-col-8 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }
    @media only screen and (width: 1024px) and (orientation: portrait) {
      .ant-col-8 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  }

  .layout-view {
    padding: 100px 150px 0 150px;

    @media only screen and (max-width: 915px) {
      padding: 100px 50px 0 50px;

      .ant-row {
        flex-direction: column-reverse;
      }

      .ant-row.row-view {
        flex-direction: column;
      }

      .ant-col-6 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-17 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-offset-1 {
        margin-left: 0 !important;
      }
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }
  }

  .link-web {
    display: block;
    color: var(--black);

    &.dentistry {
      color: #774f9f;

      u {
        color: #774f9f;
        padding-right: 10px;
      }
    }

    &.eng {
      u {
        color: #bf374f;
      }

      a {
        &:hover {
          color: #bf374f;
        }
      }
    }
    &.medicine {
      u {
        color: #176543;
      }

      a {
        &:hover {
          color: #176543;
        }
      }
    }
    &.science {
      u {
        color: #fcce0e;
      }
      a {
        &:hover {
          color: #fcce0e;
        }
      }
    }

    &.public-health {
      u {
        color: #f28dba;
      }

      a {
        &:hover {
          color: #f28dba;
        }
      }
    }

    &.text-link-image {
      u {
        color: #4675b5;
      }
    }

    a {
      color: var(--black);
      margin-left: 8px;

      &:hover {
        color: var(--secondary);
      }
    }

    &.left-none {
      a {
        margin-left: 0;
      }
    }
  }

  .link-qr {
    display: block;
    line-height: 40px;
    a {
      color: #176543;
      margin-left: 8px;

      &:hover {
        color: var(--secondary);
      }
    }
  }

  .row-title {
    .video-react .video-react-poster {
      border-radius: 20px !important;
    }
    .video-react .video-react-video {
      border-radius: 20px !important;
      width: 100%;
      height: 100%;
    }
  }

  .ant-breadcrumb-separator {
    font-size: 16px;
  }

  .row-top {
    margin-left: 30px;
  }

  .bg-circle {
    z-index: 1;
    position: relative;

    img {
      z-index: -1;
      position: absolute;
      left: -50px;
      top: -40px;
      width: 133px;
    }
  }

  @media screen and (max-width: 414px) {
    .bg-circle img {
      left: -28px !important;
      top: -28px !important;
    }
    .row-top {
      margin-left: 0 !important;
    }
  }

  @media only screen and (max-width: 414px) {
    padding: 130px 25px 0 25px !important;
  }

  @media only screen and (max-width: 912px) {
    padding: 150px 50px 0 50px !important;
  }

  @media only screen and (max-width: 1280px) {
    .row-title {
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-11 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }

      .ant-col-offset-1 {
        margin-left: 0 !important;
      }
    }
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    padding: 150px 80px 0 80px !important;

    .row-title {
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-11 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }

      .ant-col-offset-1 {
        margin-left: 0 !important;
      }
    }
  }

  @media only screen and (max-width: 1024px) {
    padding: 150px 110px 0 110px;

    .row-title {
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-11 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }

      .ant-col-offset-1 {
        margin-left: 0 !important;
      }
    }
  }

  @media only screen and (min-width: 1440px) {
    .col-image-profile {
      padding-bottom: 20px;
      padding-top: 20px;
    }
  }

  .row-name-course {
    padding-left: 50px;
    padding-top: 8px;
  }

  @media screen and (max-width: 375px) {
    .row-name-course {
      padding-top: 0 !important;
    }
  }

  @media screen and (max-width: 767px) {
    .row-name-course {
      padding-left: 30px;
      padding-top: 22px;

      .ant-col-8 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
        row-gap: 4px !important;
      }
    }
  }

  @media screen and (min-width: 375px) and (max-width: 667px) and (orientation: landscape) {
    .row-name-course {
      padding-left: 30px;

      .ant-col-8 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  }

  @media screen and (min-width: 414px) and (max-width: 896px) and (orientation: landscape) {
    .row-name-course {
      padding-left: 30px;

      .ant-col-8 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  }

  @media only screen and (width: 1024px) and (orientation: portrait) {
    .row-name-course {
      padding-left: 30px;

      .ant-col-8 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  }

  @media only screen and (min-width: 1440px) {
    .row-name-course {
      padding-top: 10px;
    }
  }

  .row-question {
    padding-left: 50px;
    padding-top: 10px;
  }

  @media screen and (max-width: 375px) {
    .row-question {
      padding-top: 0 !important;
    }
  }

  @media screen and (max-width: 767px) {
    .row-question {
      /* padding-top: 100px; */
      padding-left: 30px;
      padding-top: 22px;
      row-gap: 4px !important;

      .ant-col-8 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }

    .row-system {
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }
  }

  @media screen and (min-width: 375px) and (max-width: 667px) and (orientation: landscape) {
    .row-question {
      padding-left: 30px;

      .ant-col-8 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  }

  @media screen and (min-width: 414px) and (max-width: 896px) and (orientation: landscape) {
    .row-question {
      padding-left: 30px;

      .ant-col-8 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  }

  @media only screen and (width: 1024px) and (orientation: portrait) {
    .row-question {
      padding-left: 30px;

      .ant-col-8 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  }

  @media only screen and (min-width: 1440px) {
    .row-question {
      padding-top: 25px;
    }
  }

  @media screen and (max-width: 912px) {
    .row-detail-card {
      .ant-col-8 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
        display: grid;
      }
      .ant-col-6 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
        display: grid;
      }
    }
  }

  .row-group {
    margin-top: 5%;
    margin-left: 30px;

    .ant-carousel {
      width: 100%;
    }

    .btn-readding {
      background-color: #f4d650;
      width: 220px;
      padding: 18px;
      border-radius: 37px;
      cursor: pointer;
      margin-bottom: 30px;
      margin-left: 30px;

      p {
        font-family: "Noto Sans Thai";
        font-size: 26px;
        text-align: center;
        margin-bottom: 0;
        color: #353535;
      }
    }
  }

  @media screen and (max-width: 912px) {
    .row-group {
      margin-left: 0;

      .btn-readding {
        margin-left: 0;
      }

      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-11 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-offset-1 {
        margin-left: 0;
      }
    }
  }

  .row-contact {
    margin-left: 30px;
    margin-top: 80px;
  }

  @media screen and (max-width: 767px) {
    .row-group.crepes {
      .ant-col-8 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }
    .row-contact {
      margin-left: 0;

      .ant-col-8 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-15 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-offset-1 {
        margin-left: 0;
      }
    }
  }

  @media only screen and (width: 1024px) and (orientation: portrait) {
    .row-contact {
      margin-left: 0;

      .ant-col-8 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
      .ant-col-15 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-offset-1 {
        margin-left: 0;
      }
    }
  }

  @media screen and (max-width: 1280px) {
    .row-contact {
      margin-left: 0;

      .ant-col-8 {
        flex: 0 0 100%;
        max-width: 100%;
      }
      .ant-col-15 {
        flex: 0 0 100%;
        max-width: 100%;
      }

      .ant-col-offset-1 {
        margin-left: 0;
      }
    }
  }

  .img-people {
    width: 100%;
    height: auto;
    margin: 30px 0;
    border-radius: 20px;
    min-height: 261px;

    .video-react-poster {
      border-radius: 20px;
      background-size: cover !important;
    }

    @media only screen and (max-width: 375px) {
      margin: 30px 0 !important;
    }

    @media only screen and (max-width: 414px) {
      margin: 15px 0;
    }

    @media only screen and (max-width: 912px) {
      margin: 20px 0;
    }
  }

  .img-wrapper {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    object-fit: cover;
    height: 600px;
    max-width: 100%;
    margin: 50px 0;
  }
  .img-backgruond {
    object-fit: cover;
    position: absolute;
    height: 100%;
    width: 0;
    max-width: 900px;
    border-radius: 20px;
  }

  @media only screen and (max-width: 1439px) {
    .img-backgruond {
      width: 100% !important;
    }
    .img-wrapper {
      height: 400px;
    }
  }

  @media only screen and (max-width: 414px) {
    .img-wrapper {
      height: 200px !important;
    }
  }

  @media only screen and (width: 1024px) {
    .img-wrapper {
      height: 500px !important;
    }
  }
`;

export const CusttomBreadcrumb = styled(Breadcrumb)`
  margin-bottom: 10px;
  span {
    font-family: ${(props) =>
      props.bold ? "Noto Sans Thai Bold" : "Noto Sans Thai"};
    font-size: 16px;
    text-align: left;
  }
`;

export const Href = styled(Link)`
  color: var(--black);
  width: fit-content;
  cursor: pointer;
  background-image: linear-gradient(
    to right,
    var(--third),
    var(--secondary) 50%,
    #000 50%
  );
  background-size: 200% 100%;
  background-position: -100%;
  display: block;
  padding: 0;
  position: relative;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  transition: all 0.3s ease-in-out;

  &:before {
    content: "";
    background: var(--secondary);
    display: block;
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 0;
    height: 3px;
    transition: all 0.3s ease-in-out;
  }

  &:hover {
    background-position: 0;
  }

  &:hover::before {
    width: 100%;
  }
`;

export const Title = styled.p`
  font-family: "Noto Sans Thai";
  line-height: 140px;
  font-size: clamp(36px, 2.5vw, 80px);
  text-align: left;
  margin-bottom: 0;
  padding-bottom: 0;

  @media only screen and (max-width: 912px) {
    line-height: 50px !important;
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    line-height: 60px !important;
  }

  @media only screen and (max-width: 1024px) {
    line-height: 70px;
  }

  @media only screen and (min-width: 1440px) {
    line-height: 80px;
  }

  @media only screen and (min-width: 1400px) {
    font-size: 108px;
    line-height: 120px;
  }

  @media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
    font-size: 52px;
  }
  @media screen and (max-width: 1400px) and (orientation: landscape) {
    line-height: 80px;
    font-size: 52px;
  }
`;

export const TitleEN = styled.p`
  font-family: "Brevia Light Italic";
  line-height: 0;
  font-size: clamp(24px, 2.5vw, 35px);
  text-align: left;
  margin-left: 4px;
  line-height: 38px;
`;

export const BlockName = styled.div`
  width: 100%;
  text-align: left;
  padding-top: 42px;
  min-height: 130px;

  img {
    position: absolute;
    z-index: 1;
  }

  @media screen and (max-width: 375px) {
    min-height: ${(props) => (props.row === 3 ? "170px" : "160px")} !important;
  }

  @media screen and (max-width: 414px) {
    padding-top: 32px !important;
    min-height: ${(props) => (props.row === 3 ? "160px" : "150px")};
  }

  @media screen and (max-width: 912px) {
    padding-top: 32px !important;
    min-height: ${(props) => (props.row === 3 ? "160px" : "150px")};
  }

  @media only screen and (min-width: 1280px) {
    min-height: 170px;
  }

  @media only screen and (min-width: 1440px) {
    min-height: 164px;
  }
`;

export const TextName = styled.p`
  font-family: "Noto Sans Thai";
  text-align: left;
  font-size: clamp(40px, 2.5vw, 60px);
  line-height: 80px;
  position: absolute;
  z-index: 1;
  margin-left: 30px;
  top: 50px;
  display: grid;
  margin-bottom: 0px;

  @media only screen and (max-width: 414px) {
    font-size: 30px !important;
    top: 50px !important;
    line-height: 42px !important;
  }

  @media only screen and (max-width: 912px) {
    line-height: 60px;
  }

  /* @media screen and (max-width: 1024px) {
    line-height: 42px;
  } */

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    left: 10px;
    top: 60px;
  }

  @media only screen and (min-width: 1181px) {
    left: 10px;
  }

  @media only screen and (min-width: 1440px) {
    font-size: 50px;
    line-height: 100px;
  }

  span {
    font-family: "Noto Sans Thai Bold";
    text-align: left;
    font-size: clamp(20px, 2.5vw, 30px);
    line-height: 45px;
  }

  @media only screen and (max-width: 320px) {
    span {
      line-height: 36px !important;
    }
  }

  @media only screen and (max-width: 414px) {
    span {
      line-height: 36px;
    }
  }

  @media only screen and (max-width: 912px) {
    span {
      line-height: 32px;
    }
  }

  @media only screen and (min-width: 1440px) {
    span {
      font-size: 40px;
      line-height: 50px;
    }
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    span {
      left: 10px;
    }
  }
  @media only screen and (min-width: 1181px) {
    span {
      left: 10px;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
    span {
      font-size: 30px;
    }
  }
`;

export const DetailTop = styled.p`
  font-family: "Noto Sans Thai";
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;
  line-height: 40px;
  margin-top: 42px;
  text-indent: 60px;
  margin-bottom: ${(props) => (props.bottom ? `${props.bottom}px` : "32px")};

  @media only screen and (max-width: 414px) {
    margin-top: 22px !important;
  }

  @media only screen and (max-width: 912px) {
    margin-top: 20px !important;
  }

  @media only screen and (max-width: 1080px) {
    margin-top: 30px !important;
  }

  @media only screen and (max-width: 1420px) {
    margin-top: 70px;
  }

  @media only screen and (min-width: 1440px) {
    margin-bottom: ${(props) => (props.bottom ? `${props.bottom}px` : "28px")};
    margin-top: 90px;
  }

  /* @media only screen and (min-width: 1500px) {
    margin-bottom: ${(props) => (props.bottom ? `${props.bottom}px` : "28px")};
    margin-top: 70px;
  } */
`;

export const DetailBottom = styled.p`
  font-family: "Noto Sans Thai";
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;
  line-height: 40px;
  text-indent: 60px;
  margin-top: ${(props) => props.top && `${props.top}px`};
  margin-bottom: ${(props) => (props.bottom ? `${props.bottom}px` : "32px")};
`;

export const NameCourse = styled.p`
  font-family: "Noto Sans Thai";
  text-align: ${(props) => (props.align ? props.align : "left")};
  font-size: clamp(20px, 2.5vw, 24px);
  line-height: 30px;
  margin-left: ${(props) =>
    props.left ? `${props.left}px` : "5px"} !important;
  margin-bottom: ${(props) => (props.bottom ? `${props.bottom}px` : "2px")};

  color: ${(props) => (props.color ? props.color : "var(--black)")};

  min-height: ${(props) =>
    props.height ? `${props.height}px` : "50px"} !important;
  margin-top: ${(props) => (props.top ? `${props.top}px` : "20px")};

  @media screen and (max-width: 414px) {
    min-height: 10px !important;
  }

  @media screen and (max-width: 1440px) {
    min-height: auto !important;
  }
  @media only screen and (min-width: 1440px) {
    min-height: auto !important;
  }

  @media only screen and (max-width: 1024px) and (orientation: portrait) {
    line-height: 28px !important;
  }

  @media only screen and (width: 1024px) and (orientation: portrait) {
    min-height: auto !important;
  }
`;

export const HoverAni = styled.div`
  width: fit-content;
  position: relative;
  text-decoration: none;

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 4px;
    background-color: var(--secondary);
    bottom: -8px;

    left: 0;
    transform-origin: right;
    transform: scaleX(0);
    transition: transform 0.3s ease-in-out;
  }

  &:hover::before {
    transform-origin: left;
    transform: scaleX(1);
  }
`;

export const FixBox = styled.div`
  background-color: ${(props) => (props.bg ? props.bg : "var(--while)")};

  padding: 100px 158px 50px 158px;
  margin: 100px -158px 50px -158px;

  @media only screen and (max-width: 414px) {
    padding: 100px 50px 50px 50px !important;
    margin: 100px -50px 50px -50px !important;
  }

  @media only screen and (max-width: 912px) {
    padding: 100px 80px 50px 80px;
    margin: 100px -80px 50px -80px;
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    padding: 100px 80px 50px 80px !important;
    margin: 100px -80px 50px -80px !important;
  }

  @media only screen and (max-width: 1024px) {
    padding: 100px 110px 50px 110px;
    margin: 100px -110px 50px -110px;
  }

  .row-group {
    margin-top: 0 !important;
  }
`;

export const SubTitle = styled.p`
  font-family: "Noto Sans Thai Bold";
  text-align: ${(props) => (props.align ? props.align : "left")};
  font-size: clamp(22px, 2.5vw, 40px);
  line-height: 50px;
  margin-left: 30px;
  margin-top: ${(props) => props.top && `${props.top}px`};
  margin-bottom: ${(props) =>
    props.bottom ? `${props.bottom}px` : "32px"} !important;

  @media screen and (max-width: 912px) {
    line-height: 40px !important;
    margin-top: 10% !important;
    margin-left: 0 !important;
  }

  @media screen and (max-width: 1024px) {
    line-height: 40px;
  }
`;

export const SubDetail = styled.p`
  font-size: clamp(20px, 2.5vw, 24px);
  font-family: "Noto Sans Thai";
  text-align: ${(props) => (props.align ? props.align : "left")};
  line-height: 40px;
  margin-top: ${(props) => (props.top ? `${props.top}px` : "28px")} !important;
  margin-left: ${(props) =>
    props.left ? `${props.left}px` : "30px"} !important;

  text-indent: ${(props) => props.indent && `${props.indent}px`};
  margin-bottom: ${(props) =>
    props.bottom ? `${props.bottom}px` : "32px"} !important;
  color: ${(props) => (props.color ? props.color : "var(--black)")};

  @media screen and (max-width: 414px) {
    margin-left: 0 !important;
  }

  z-index: 1;
  position: relative;

  u {
    &:hover {
      color: var(--secondary);
    }
  }

  .link-web.bold {
    font-family: "Noto Sans Thai Bold";
    a {
      color: #81000f !important;
    }
  }
`;

export const CustomCarousel = styled(Carousel)`
  img {
    border-radius: ${(props) =>
      props.radius ? props.radius : "20px"} !important;
    width: 100% !important;
    margin: 20px 0;
  }

  .slick-track {
    transition: -webkit-transform 900ms linear 900ms !important;
  }

  .slick-dots {
    li {
      width: 26px !important;
      height: 26px !important;
      border-radius: 100% !important;
      background: #fff !important;
      border: 1px solid ${(props) => (props.bg ? props.bg : "var(--while)")};
      margin: 0 10px !important;
    }

    li.slick-active {
      background: ${(props) =>
        props.bg ? props.bg : "var(--while)"} !important;
    }

    @media only screen and (max-width: 414px) {
      li {
        width: 13px !important;
        height: 13px !important;
        margin: 0 5px !important;
      }
    }
  }

  .slick-dots {
    li button {
      width: 26px !important;
      height: 26px !important;
      border-radius: 100% !important;
      background: #fff !important;
      border: 1px solid ${(props) => (props.bg ? props.bg : "var(--while)")};
    }

    li.slick-active button {
      background: ${(props) =>
        props.bg ? props.bg : "var(--while)"} !important;
    }

    @media only screen and (max-width: 414px) {
      li button {
        width: 13px !important;
        height: 13px !important;
      }
    }
  }

  .slick-dots {
    z-index: 1 !important;
  }
`;

export const SubHead = styled.p`
  font-family: ${(props) => (props.font ? props.font : "Noto Sans Thai Bold")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  font-size: clamp(20px, 2.5vw, 24px);
  line-height: 35px;
  margin-left: ${(props) => (props.left ? `${props.left}px` : "30px")};

  display: flex;
  margin-top: ${(props) => (props.top ? `${props.top}px` : "auto")};
  margin-bottom: ${(props) => (props.bottom ? `${props.bottom}px` : "32px")};

  @media only screen and (min-width: 1440px) {
    min-height: ${(props) => props.height && `${props.height}px`};
  }
  ${(props) =>
    props.weight === "bold" &&
    `
     font-weight: 600;
    `}

  ${(props) =>
    props.align === "center" &&
    `
     justify-content: center;
    `}

  a {
    font-family: "Noto Sans Thai";
    text-align: left;
    font-size: clamp(20px, 2.5vw, 24px);
    line-height: 35px;
    display: flex;
    color: ${(props) => (props.color ? props.color : "var(--black)")};
  }

  img {
    cursor: pointer;
    margin-right: 18px;
    height: 36px;
  }
`;

export const Float = keyframes`
  0% {
		transform: translatey(0px);
	}
	50% {
		transform: translatey(-20px);
	}
	100% {
		transform: translatey(0px);
	}
`;

export const CardContact = styled.div`
  width: 100%;
  background-color: ${(props) =>
    props.background ? props.background : "#fff"};
  border-radius: 20px;
  margin-bottom: 35px;

  .container {
    padding-top: 0px;
    padding-right: 25px;
    padding: 50px 30px 20px 5px;
    position: absolute;
  }
`;

export const FixBoxLayout = styled.div`
  background-color: ${(props) => (props.bg ? props.bg : "var(--while)")};
  margin: 100px -158px 50px -158px;

  @media only screen and (max-width: 414px) {
    margin: 100px -50px 50px -50px !important;
    padding: 0 25px;

    .title-tech {
      padding: 0 50px;
    }
  }

  @media only screen and (max-width: 912px) {
    margin: 100px -80px 50px -80px;
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    margin: 100px -80px 50px -80px !important;
  }

  @media only screen and (max-width: 1024px) {
    margin: 100px -110px 50px -110px;
  }

  .row-group {
    margin-top: 0 !important;
  }
`;

export const View = styled.p`
  font-family: "Noto Sans Thai";
  line-height: 140px;
  font-size: clamp(80px, 2.5vw, 100px);
  text-align: center;
  margin-bottom: 0;
  padding-bottom: 0;
  margin-left: 30px;

  @media only screen and (min-width: 1400px) {
    font-size: 100px;
    line-height: 120px;
  }
`;
